/* eslint-disable react/prop-types */
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { appContext } from "Router/routes";
import Action from "../ActionPopOver";
import "./index.scss";
import { MemberCardFamilyMembers } from "./Theme";

const MyCard = ({
  ClassName,
  onClick,
  member,
  cardColor,
  setAccountId,
  setAccountById,
  setOpenAlert,
  onMergeClick
}) => {

  const history = useHistory();
  const { setTypeUser } = useContext(appContext);
  const [isFinanceActive, setIsFinanceActive] = useState(true);

  function AccountFamilyMembers() {
    return (
      <MemberCardFamilyMembers className="avatar-container"
        color={cardColor.color}
        backgroundColor={cardColor.background}
      >
        <AvatarGroup max={4}
          sx={
            {
              "& .MuiAvatar-colorDefault": {
                width: "30px",
                height: "30px",
                fontSize: "12px",
                fontWeight: "bold",
                backgroundColor: "rgba(0, 0, 0, 0.1)",
              },
            }
          }
        >
          {member?.family_members?.length &&
            member?.family_members.map((family_member, index) => {
              return (
                <Avatar
                  key={index}
                  alt={family_member?.first_name}
                  src={family_member?.profile_img}
                  style={cardColor}
                >
                  {(
                    family_member.first_name?.[0] + family_member.last_name?.[0]
                  )?.toString()?.toUpperCase()}
                </Avatar>
              );
            })}
          {!member?.family_members?.length ? <div></div> : ""}
        </AvatarGroup>
      </MemberCardFamilyMembers>
    );
  }


  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "finance") {
        return setIsFinanceActive(item?.active);
      }
    });
  }, []);
  return (
    <div className={`my-card mt-5 ${ClassName}`}>
      <Card className="card-body p-0">
        <div className="px-3 pt-3">
          <div className="header clickable" style={cardColor}>
            <div className="d-flex justify-content-between pb-2">
              {member?.payment?.account_type ? (
                <div
                  className="account-type clickable text-capitalize"
                  style={{ backgroundColor: `rgba(${cardColor.bgColor}, 0.2)` }}
                >
                  {member?.payment?.account_type}
                </div>
              ) : <div></div>}
              <IconButton className="p-0 px-2" onClick={() => setAccountById(member)}>
                <Action
                  onEditClick={() => {
                    setTypeUser(false);
                    history.push(`/member-details/${member._id}`);
                  }}
                  onDeleteClick={() => {
                    setAccountId(member._id);
                    setOpenAlert(true);
                  }}
                  onMergeClick={onMergeClick}
                  style={{
                    color: cardColor.color,
                    width: "16px",
                    height: "16px",
                  }}
                  checkActive={true}
                />
              </IconButton>
            </div>
            <div className="member-name">
              <div className="name"
                onClick={() => {
                  setTypeUser(false);
                  history.push(`/member-details/${member._id}`);
                }}
              >
                {member?.family_name}
              </div>
              <p className="id-number" onClick={onClick}>
                {member?.account_id ? "#" + member?.account_id : <br />}
              </p>
            </div>
          </div>
          <div className="family pt-5 clickable" onClick={onClick}>
            <div className="family-header pb-3">
              <AccountCircleIcon style={{ marginRight: 5, marginBottom: 2 }} />
              <span>{member?.payment?.account_sub_type?.title}</span>
            </div>
            <AccountFamilyMembers />
          </div>
        </div>
        {/* <hr /> */}
        <div className="px-5 clickable" onClick={onClick}>
          <div className="payment-type pb-5">
            {member?.payment?.product_id?.prod_name ? (
              member?.payment?.product_id?.prod_name
            ) : (
              <br />
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default MyCard;
